import React from 'react'
import AdminAnnouncementList from './AdminAnnouncementList'
import { EventsContainer } from '../styles'

const AdminAnnouncement = () => {
	return (
		<EventsContainer>
			<AdminAnnouncementList />
		</EventsContainer>
	)
}

export default AdminAnnouncement
